// extracted by mini-css-extract-plugin
export default {"container":"navItemWithIcon_container__GhQ5K","icon":"navItemWithIcon_icon__GCmwk","text":"navItemWithIcon_text__S5zIf"};